import jsPDF from "jspdf";
import "jspdf-autotable";
import { getLoginInfo } from "../utils/storage";
import { ImmLogo } from "../../assets/img/logoImm";

export const generatePDF = (listData, reportType) => {
  const data = listData?.PoolList || listData?.data?.PoolList || [];
  const firstStationRow = Array.isArray(data)
    ? data.find((item) => item?.ReceivedStation || item?.IssuedAt || item?.Station)
    : null;
  const stationFromList =
    firstStationRow?.ReceivedStation || firstStationRow?.IssuedAt || firstStationRow?.Station || "";
  const station =
    reportType?.ReportType === "get_etd_reports_by_admin"
      ? stationFromList || getLoginInfo()?.user?.StationName
      : getLoginInfo()?.user?.StationName;
  const username = getLoginInfo()?.user?.Username;
  const logo = ImmLogo.logo;
  const newList = Array.isArray(data) ? data : [];

  // Declare with `let` because we'll reassign
  let documentType = "";
  let reportTitle = "";

  // Format the dates
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d
      .toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
      .replace(",", "");
  };

  const formattedStartDate = formatDate(reportType?.StartDate);
  const formattedEndDate = formatDate(reportType?.EndDate);

  // Assign document type
  switch (reportType?.DocTypeID) {
    case "1":
    case "4":
      documentType = "PASSPORT";
      break;
    case "2":
      documentType = "PREVIOUS ETD";
      break;
    case "3":
    case "5":
      documentType = "NIN";
      break;
    default:
      documentType = "UNKNOWN";
  }

  // Assign report title
  switch (reportType?.ReportType) {
    case "issued_etd_reports":
      reportTitle = `${station?.toUpperCase()} ISSUED ETD REPORT FROM ${formattedStartDate?.toUpperCase()} TO ${formattedEndDate?.toUpperCase()}`;
      break;
    case "payments_report":
      reportTitle = `${station?.toUpperCase()} ETD PAYMENT REPORT FROM ${formattedStartDate?.toUpperCase()} TO ${formattedEndDate?.toUpperCase()}`;
      break;
    case "get_etd_reports_by_admin":
      reportTitle = `ETD ADMIN REPORT FROM ${formattedStartDate?.toUpperCase()} TO ${formattedEndDate?.toUpperCase()} AT ${station?.toUpperCase()}`;
      break;
      
    case "defined_reports":
      reportTitle = `${station?.toUpperCase()} DEFINED REPORT FROM ${formattedStartDate?.toUpperCase()} TO ${formattedEndDate?.toUpperCase()}`;
      break;
    default:
      reportTitle = `${station?.toUpperCase()} REPORT`;
  }

  return new Promise((resolve, reject) => {
    try {
      const pdf = new jsPDF("l", "px", "a4", true);
      const date = new Date();
      const today = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      const pageWidth = pdf.internal.pageSize.width;

      // Header
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(12);
      const headerText = "TANZANIA IMMIGRATION SERVICES DEPARTMENT";
      pdf.text(headerText, (pageWidth - pdf.getTextWidth(headerText)) / 2, 45);

      pdf.setFontSize(11);
      const subHeaderText = "ETD MANAGEMENT SYSTEM";
      pdf.text(
        subHeaderText,
        (pageWidth - pdf.getTextWidth(subHeaderText)) / 2,
        60,
      );

      // Logo
      pdf.addImage(logo, "png", pageWidth / 2 - 20, 65, 40, 40);

      // Report title
      pdf.setFontSize(10);
      pdf.text(
        reportTitle,
        (pageWidth - pdf.getTextWidth(reportTitle)) / 2,
        120,
      );

      if (listData?.TotalETDPerStation) {
        pdf.text(`TOTAL APPLICATIONS: ${listData.TotalETDPerStation}`, 30, 135);
      }

      if (listData?.TotalStationPayments) {
        const formattedTotal = Number(
          listData.TotalStationPayments,
        ).toLocaleString();
        pdf.text(`TOTAL PAYMENTS: ${formattedTotal}`, 30, 150);
      }

      const finalY2 = 170;
      pdf.text("APPLICATION LIST", 30, finalY2);
      // {
      //         "Amount": 20000,
      //         "ApplicationID": "E20250521000957",
      //         "FullName": "YUSUPH THOBIAS MADEGE",
      //         "PaymentControlNo": 991097190542,
      //         "ReceiptDate": "2025-05-21T22:32:27"
      //       },

      // By document search
      //  {
      //   "ApplicationID": "E20250521000664",
      //   "ETDNumber": "AB10024994",
      //   "ExpiredDate": "May 21 2026",
      //   "FullName": "ARUBU HAMIS ABDULL",
      //   "IssuedAt": "Songwe",
      //   "IssuedDate": "May 21 2025",
      //   "PaymentControlNo": "991097189545"
      // },
      // Table headers

      const headerDefined = [
        "SN",
        "APPLICATION ID",
        "FULL NAME",
        "ETD NUMBER",
        "CONTROL NUMBER",
        "ISSUE DATE",
        "EXPIRE DATE",
      ];
      const headerPayment = [
        "SN",
        "APPLICATION ID",
        "FULL NAME",
        "AMOUNT",
        "CONTROL NUMBER",
        "PAYMENT DATE",
      ];
      let reportHeader = "";
      switch (reportType?.ReportType) {
        case "issued_etd_reports":
        case "get_etd_reports_by_doctype":
          case "get_etd_reports_by_admin":
        case "defined_reports":
          reportHeader = headerDefined;
          break;
        case "payments_report":
          reportHeader = headerPayment;
      }
      // const  reportHeader = reportType?.ReportType === "issued_etd_reports" ? headerDefined : headerPayment;
      // const reportHeader = reportType?.ReportType === "issued_etd_reports" ? headerDefined : headerPayment;

      // Chunking
      const CHUNK_SIZE = 100;
      const chunks = [];
      for (let i = 0; i < newList.length; i += CHUNK_SIZE) {
        chunks.push(newList.slice(i, i + CHUNK_SIZE));
      }

      let startY = finalY2 + 10;

      switch (reportType?.ReportType) {
        case "issued_etd_reports":
        case "defined_reports":
        case "get_etd_reports_by_admin":
          case "get_etd_reports_by_doctype":
          chunks.forEach((chunk, chunkIndex) => {
            const rows = chunk.map((applicant, i) => {
              const sn = i + 1 + chunkIndex * CHUNK_SIZE;
              return [
                sn,
                applicant?.ApplicationID,
                applicant?.FullName,
                applicant?.ETDNumber,
                applicant?.PaymentControlNo,
                applicant?.IssuedDate,
                applicant?.ExpiredDate,
              ];
            });

            pdf.autoTable({
              startY,
              head: [reportHeader],
              body: rows,
              margin: { top: 10 },
              didDrawPage: (data) => {
                startY = data.cursor.y + 20;
              },
            });
          });
          break;

        //search by payment
        case "payments_report":
          chunks.forEach((chunk, chunkIndex) => {
            const rows = chunk.map((applicant, i) => {
              const sn = i + 1 + chunkIndex * CHUNK_SIZE;
              return [
                sn,
                applicant.ApplicationID,
                applicant.FullName,
                applicant.Amount,
                applicant.PaymentControlNo,
                applicant.ReceiptDate,
              ];
            });

            pdf.autoTable({
              startY,
              head: [reportHeader],
              body: rows,
              margin: { top: 10 },
              didDrawPage: (data) => {
                startY = data.cursor.y + 20;
              },
            });
          });
          break;
      }

      // chunks.forEach((chunk, chunkIndex) => {
      //   const rows = chunk.map((applicant, i) => {
      //     const sn = i + 1 + chunkIndex * CHUNK_SIZE;
      //     return reportType?.ReportType === "issued_etd_reports"
      //       ? [
      //         sn,
      //         applicant?.ApplicationID,
      //         applicant?.FullName,
      //         applicant?.ETDNumber,
      //         applicant?.PaymentControlNo,
      //         applicant?.IssuedDate,
      //         applicant?.ExpiredDate,
      //       ]
      //       : [
      //         sn,
      //         applicant.ApplicationID,
      //         applicant.FullName,
      //         applicant.Amount,
      //         applicant.PaymentControlNo,
      //         applicant.ReceiptDate,
      //       ];
      //   });

      //   pdf.autoTable({
      //     startY,
      //     head: [reportHeader],
      //     body: rows,
      //     margin: { top: 10 },
      //     didDrawPage: (data) => {
      //       startY = data.cursor.y + 20;
      //     },
      //   });
      // });

      // Footer
      const pageCount = pdf.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(6);
        const footerText = `TANZANIA IMMIGRATION SERVICES - Page ${i} of ${pageCount} | Printed ${today} by ${username}`;
        pdf.text(footerText, 255, 440);
      }

      pdf.save(`Report_${today}.pdf`);
      resolve(); // Resolving the promise if needed
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

// export const generatePDF = (listData, reportType) => {
//   const data = listData?.PoolList || [];
//   const station = getLoginInfo()?.user?.Station;
//   const username = getLoginInfo()?.user?.Username;
//   const logo = ImmLogo.logo;
//   const newList = data != '0' ? data?.length >= 0 ? data : [] : [];

//   return new Promise((resolve, reject) => {
//     try {
//       const pdf = new jsPDF("l", "px", "a4", true); // 'true' enables compression
//       const date = new Date();
//       const today = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
//       const pageWidth = pdf.internal.pageSize.width;

//       // Header
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(12);
//       const headerText = "TANZANIA IMMIGRATION DEPARTMENTS SERVICES";
//       const headerWidth = pdf.getTextWidth(headerText);
//       pdf.text(headerText, (pageWidth - headerWidth) / 2, 45);

//       pdf.setFontSize(11);
//       const subHeaderText = "ETD MANAGEMENT SYSTEM";
//       const subHeaderWidth = pdf.getTextWidth(subHeaderText);
//       pdf.text(subHeaderText, (pageWidth - subHeaderWidth) / 2, 60);

//       // Logo
//       pdf.addImage(logo, "png", (pageWidth / 2) - 20, 65, 40, 40);

//       // Report title
//       const reportTitle = `${station?.toUpperCase()} ISSUED ETD REPORT FROM ${reportType?.StartDate} TO ${reportType?.EndDate}`;
//       const titleWidth = pdf.getTextWidth(reportTitle);
//       pdf.text(reportTitle, (pageWidth - titleWidth) / 2, 120);

//       pdf.setFontSize(10);
//       if (listData?.TotalETDPerStation) {
//         pdf.text(`TOTAL APPLICATIONS: ${listData?.TotalETDPerStation}`, 30, 135);
//       }

//       if (listData?.TotalStationPayments) {
//         const formattedTotal = Number(listData.TotalStationPayments).toLocaleString();
//         pdf.text(`TOTAL PAYMENTS: ${formattedTotal}`, 30, 150);
//       }

//       const finalY2 = 170;
//       pdf.text("APPLICATION LIST", 30, finalY2);

//       // Table headers
//       const headerDefined = ["SN", "APPLICATION ID", "FULL NAME", "ETD NUMBER", "CONTROL NUMBER", "ISSUE DATE", "EXPIRE DATE"];
//       const headerPayment = ["SN", "APPLICATION ID", "FULL NAME", "ETD NUMBER", "CONTROL NUMBER", "RECEIPT NUMBER", "RECEIPT DATE", "ISSUED AT"];
//       const reportHeader = reportType?.ReportType === "issued_etd_reports" ? headerDefined : headerPayment;

//       // Chunking
//       const CHUNK_SIZE = 100;
//       const chunks = [];
//       for (let i = 0; i < newList.length; i += CHUNK_SIZE) {
//         chunks.push(newList.slice(i, i + CHUNK_SIZE));
//       }

//       let startY = finalY2 + 10;

//       chunks.forEach((chunk, chunkIndex) => {
//         const rows = chunk.map((applicant, i) => {
//           const sn = i + 1 + chunkIndex * CHUNK_SIZE;
//           return reportType?.ReportType === "issued_etd_reports"
//             ? [
//               sn,
//               applicant?.ApplicationID,
//               applicant?.FullName,
//               applicant?.ETDNumber,
//               applicant?.PaymentControlNo,
//               applicant?.IssuedDate,
//               applicant?.ExpiredDate,
//             ]
//             : [
//               sn,
//               applicant.ApplicationID,
//               applicant.FullName,
//               applicant.ETDNumber,
//               applicant.PaymentControlNo,
//               applicant.ReceiptNo,
//               applicant.ReceiptDate,
//               applicant.IssuedAt,
//             ];
//         });

//         pdf.autoTable({
//           startY,
//           head: [reportHeader],
//           body: rows,
//           // theme: "grid",
//           margin: { top: 10 },
//           didDrawPage: (data) => {
//             startY = data.cursor.y + 20; // update Y for next chunk
//           },
//         });
//       });

//       // Add footer with page numbers
//       const pageCount = pdf.getNumberOfPages();
//       for (let i = 1; i <= pageCount; i++) {
//         pdf.setPage(i);
//         pdf.setFontSize(6);
//         const footerText = `TANZANIA IMMIGRATION SERVICES - Page ${i} of ${pageCount} | Printed ${today} by ${username}`;
//         pdf.text(footerText, 255, 440);
//       }
//       pdf.save(`Report_${today}.pdf`);
//       // Generate Base64
//       // const base64 = pdf.output("datauristring");
//       // resolve(base64);
//     } catch (error) {
//       console.error(error);
//       // toast.error(messages.technicalError);
//       reject(error);
//     }
//   });
// };
